import { Box, Button, FormControl, FormErrorMessage, FormLabel, Input, Radio, RadioGroup, Select, Stack, useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { resetEdit, resetFormStatus, setHeaderText } from "../../redux/actions/actions";
import { loadCourses, loadEmptyTopicsInstantly, loadQuizzes, loadTopicsForSelectedCourse, submitQuizForm, updateQuizForm } from "../../redux/api_calls/apiCalls";
import LoadingModal from "../common/LoadingModal";
import Tags from '../common/Tags'
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import JoditEditor from "jodit-react";

export default function FormPartOne({ setNextClicked }) {

    const [selectCourseError, setSelectCourseError] = useState(null)
    const [selectTopicError, setSelectTopicError] = useState(null)
    const [descriptionError, setDescriptionError] = useState(null)
    const [keywordsError, setKeywordsError] = useState(null)
    const [quizTitleError, setQuizTitleError] = useState(null)
    const [scheduleDateError, setScheduleDateError] = useState(null)
    const [expiryDateError, setExpiryDateError] = useState(null)
    const [scheduleDate, setScheduleDate] = useState('')
    const [expiryDate, setExpiryDate] = useState('')
    const [expiryTime, setExpiryTime] = useState('')
    const [expiryTimeError, setExpiryTimeError] = useState(null)
    const [durationError, setDurationError] = useState(null)
    const [maxAttemptsError, setMaxAttemptsError] = useState(null)
    const [keywordTags, setKeywordTags] = useState([])

    const coursesData = useSelector(state => state.coursesState.coursesData)
    const coursesLoading = useSelector(state => state.coursesState.isLoading)

    const topicsData = useSelector(state => state.topicsState.topicsData)
    const topicsLoading = useSelector(state => state.topicsState.isLoading)

    const quizzesData = useSelector(state => state.quizzesState.quizzesData)
    const quizzesIsLoading = useSelector(state => state.quizzesState.isLoading)
    const dispatch = useDispatch()
    const history = useHistory()
    const toast = useToast()

    const selectTopicRef = useRef()
    const selectCourseRef = useRef()
    const quizTitleRef = useRef()
    const durationRef = useRef()
    const maxAttemptsRef = useRef()

    const { isOpen, onOpen, onClose } = useDisclosure()

    const editState = useSelector(state => state.editState)
    const [radioButtonValue, setRadioButtonValue] = useState(null)

    const formStatus = useSelector(state => state.formStatus)
    const editor = useRef(null)
    const [content, setContent] = useState('')

    function validateQuizTitle() {
        let quizTitle = quizTitleRef.current.value.trim()
        if (!quizTitle.length) {
            setQuizTitleError("Quiz Title is required")
            return true
        }
        else {
            setQuizTitleError(null)
            return false
        }
    }

    function validateDescription() {
        let description = content
        if (!description.length) {
            setDescriptionError("Instructions are required")
            return true
        }
        else {
            setDescriptionError(null)
            return false
        }
    }

    function validateKeyword() {
        if (!keywordTags.length) {
            setKeywordsError("No Keyword Entered")
            return true
        }
        else {
            setKeywordsError(null)
            return false
        }
    }

    function validateScheduleDate() {
        if (radioButtonValue === 'mid-term') {
            setScheduleDateError(null)
            return false
        }
        let error
        let date = new Date(Date.now())
        let month = Number(date.getMonth()) + 1
        let day = Number(date.getDate())
        let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
        if (!scheduleDate.length) {
            error = "Quiz Start Date is required"
        } else if (Date.parse(scheduleDate.split('-').reverse().join('-')) < Date.parse(today)) {
            error = "Quiz Start Date cannot be less than today!"
        } else if (expiryDate.length) {
            if (Date.parse(expiryDate.split('-').reverse().join('-')) >= Date.parse(today) && Date.parse(expiryDate.split('-').reverse().join('-')) < Date.parse(scheduleDate.split('-').reverse().join('-'))) {
                error = "Quiz Start Date cannot be more than Quiz Expiry Date!"
            }
        }
        if (error) {
            setScheduleDateError(error)
            return true
        }
        else {
            setScheduleDateError(null)
            return false
        }
    }

    function validateExpiryDate() {
        if (radioButtonValue === 'mid-term') {
            setExpiryDateError(null)
            return false
        }
        let error
        let date = new Date(Date.now())
        let month = Number(date.getMonth()) + 1
        let day = Number(date.getDate())
        let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
        if (!expiryDate.length) {
            error = "Quiz Expiry Date is required"
        } else if (Date.parse(expiryDate.split('-').reverse().join('-')) < Date.parse(today)) {
            error = "Quiz Expiry Date cannot be less than today!"
        } else if (scheduleDate.length) {
            if (Date.parse(scheduleDate.split('-').reverse().join('-')) > Date.parse(expiryDate.split('-').reverse().join('-'))) {
                error = "Quiz Expiry Date cannot be earlier than Quiz Start Date!"
            }
        }
        if (error) {
            setExpiryDateError(error)
            return true
        }
        else {
            setExpiryDateError(null)
            return false
        }
    }

    function validateExpiryTime() {
        if (radioButtonValue === 'mid-term') {
            setExpiryTimeError(null)
            return false
        }
        if (!expiryTime.length) {
            setExpiryTimeError("Expiry Time is required!")
            return true
        }
        else {
            setExpiryTimeError(null)
            return false
        }
    }

    function validateMaxAttempts() {
        if (radioButtonValue === 'mid-term') {
            setMaxAttemptsError(null)
            return false
        }
        let maxAttempts = maxAttemptsRef.current.value.trim()
        if (!maxAttempts.length) {
            setMaxAttemptsError('Number of Attempts cannot be left empty!')
            return true
        }
        else if (Number(maxAttempts) === 0) {
            setMaxAttemptsError('Please enter a value greater than or equal to 1')
            return true
        }
        else if (Number(maxAttempts) < 0) {
            setMaxAttemptsError('Number of Attempts cannot be a negative value!')
            return true
        }
        else if (maxAttempts.includes('.')) {
            setMaxAttemptsError('Number of Attempts cannot contain a decimal value!')
            return true
        }
        else {
            setMaxAttemptsError(null)
            return false
        }
    }

    function validateDuration() {
        if (radioButtonValue === 'mid-term') {
            setDurationError(null)
            return false
        }
        let duration = durationRef.current.value.trim()
        if (!duration.length) {
            setDurationError('Duration cannot be left empty!')
            return true
        }
        else if (Number(duration) === 0) {
            setDurationError('Please enter a value greater than or equal to 1')
            return true
        }
        else if (Number(duration) < 0) {
            setDurationError('Duration cannot be a negative value!')
            return true
        }
        else if (duration.includes('.')) {
            setDurationError('Duration cannot contain a decimal value!')
            return true
        }
        else if (Number(duration) > 300) {
            setDurationError('Duration cannot be more than 300 minutes')
            return true
        }
        else {
            setDurationError(null)
            return false
        }
    }


    function keywordKeyPressHandler(e) {
        e.stopPropagation()
        if (e.key === 'Enter' || e.key === 'ENTER') {
            let currentKeyword = e.target.value.trim()
            if (currentKeyword.length) {
                let tempTags = [...keywordTags]
                tempTags.push(currentKeyword)
                setKeywordTags(tempTags)
                e.target.value = ''
                return false
            }
        }
    }

    const cancelHandler = () => {
        dispatch(resetEdit())
        history.push('/quizzes')
    }

    useEffect(() => {
        if (formStatus.success && !formStatus.error) {
            if (editState.flag) {
                // dispatch(resetEdit())
                toast({
                    title: "Quiz Edited Successfully!",
                    description: "Quiz Edited!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
            }
            else {
                toast({
                    title: "Quiz Added Successfully!",
                    description: "Quiz Added!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
            }
            setNextClicked(true)
        }
        else if (formStatus.error) {
            toast({
                title: formStatus.error,
                description: "Error!",
                status: "error",
                duration: 3000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.success, formStatus.error, editState.flag])


    function validateSelectCourse() {
        let selectedCourse = selectCourseRef.current.value.trim()
        if (!selectedCourse.length && !editState.flag) {
            setSelectCourseError("Select a Course!")
            return true
        }
        else {
            setSelectCourseError(null)
            return false
        }
    }

    function validateSelectTopic() {
        let selectedTopic = selectTopicRef.current ? selectTopicRef.current.value.trim() : ''
        if (radioButtonValue === 'mid-term' && !selectedTopic.length && !editState.flag) {
            setSelectTopicError("Select a Topic!")
            return true
        }
        else {
            setSelectTopicError(null)
            return false
        }
    }
    function removeTagHandler(keyword) {
        setKeywordTags(keywordTags.filter(tag => tag !== keyword))
    }

    // eslint-disable-next-line
    const validateFields = () => {
        return validateSelectCourse() || validateSelectTopic() || validateQuizTitle() || validateDescription() || validateKeyword() || validateScheduleDate() || validateExpiryDate() || validateExpiryTime() || validateDuration() || validateMaxAttempts()
    }

    const preFillForm = () => {
        const currentQuiz = quizzesData.find(quiz => quiz.id.toString() === editState.id.toString())
        console.log(currentQuiz, "in prefill")
        setRadioButtonValue(!currentQuiz.topic_id ? 'end-term' : 'mid-term')
    }

    // eslint-disable-next-line
    const updateQuiz = () => {
        const currentQuiz = quizzesData.find(quiz => quiz.id.toString() === editState.id.toString())
        let formData = { ...currentQuiz }
        let title = quizTitleRef.current.value.trim()
        let description = content
        let keywords = keywordTags.join(', ')

        if (currentQuiz.title !== title) {
            formData["title"] = title
        }

        if (currentQuiz.description !== description) {
            formData["description"] = description
        }
        if (keywords !== currentQuiz.keywords) {
            formData["keywords"] = keywords
        }
        if (!currentQuiz.topic_id) {
            let expiryDateAndTime = expiryDate.split('-').reverse().join('-') + ' ' + expiryTime + ':00'

            if (scheduleDate !== currentQuiz.start_date) {
                formData['start_date'] = scheduleDate.split('-').reverse().join('-')
            }
            if (expiryDateAndTime !== currentQuiz.end_date) {
                formData['end_date'] = expiryDateAndTime
            }
            if (durationRef.current.value.trim() !== currentQuiz.time_duration) {
                formData['duration'] = durationRef.current.value.trim()
            }
            if (Number(maxAttemptsRef.current.value.trim()) !== currentQuiz.max_no_of_attempts) {
                formData['max_no_of_attempts'] = Number(maxAttemptsRef.current.value.trim())
            }
        }


        delete formData.id
        delete formData.created_at
        delete formData.updated_at
        delete formData.question_count
        delete formData.courses
        delete formData.topics
        if (!formData.start_date) {
            delete formData.start_date
        }
        if (!formData.end_date) {
            delete formData.end_date
        }
        if (!formData.duration) {
            delete formData.duration
        }
        if (!formData.time_duration) {
            delete formData.time_duration
        }
        if (!formData.max_no_of_attempts) {
            delete formData.max_no_of_attempts
        }
        if (!formData.pass_criteria_percent) {
            delete formData.pass_criteria_percent
        }
        // console.log(formData)
        dispatch(updateQuizForm(formData, editState.id))
    }
    // eslint-disable-next-line
    const addNewQuiz = () => {
        // eslint-disable-next-line

        let formData = {
            title: quizTitleRef.current.value.trim(),
            description: content,
            keywords: keywordTags.join(', '),
            course_id: coursesData.find(course => course.title === selectCourseRef.current.value).id,
            quiz_type: radioButtonValue === 'end-term' ? 'E' : 'M',
            max_no_of_attempts: 1,
            topic_id: null
        }
        if (radioButtonValue === 'mid-term') {
            formData['topic_id'] = topicsData.find(topic => topic.title === selectTopicRef.current.value).id
        }
        else {
            let expiryDateAndTime = expiryDate.split('-').reverse().join('-') + ' ' + expiryTime + ':00'
            formData["start_date"] = scheduleDate.split('-').reverse().join('-')
            formData["end_date"] = expiryDateAndTime
            formData["time_duration"] = (durationRef.current.value.length === 1 ? "0" + durationRef.current.value : durationRef.current.value) + ":00"
            formData["max_no_of_attempts"] = Number(maxAttemptsRef.current.value)
        }
        // console.log(formData)
        dispatch(submitQuizForm(formData))
    }


    const nextHandler = () => {
        if (validateFields()) {
            setNextClicked(false)
            return
        }
        else {
            if (editState.flag) {
                updateQuiz()
            }
            else {
                addNewQuiz()
            }
        }
    }


    useEffect(() => {
        if (coursesLoading) {
            onOpen()
        }
        else {
            onClose()
        }
        // eslint-disable-next-line
    }, [coursesLoading])

    useEffect(() => {
        if (topicsLoading) {
            onOpen()
        }
        else {
            onClose()
        }
        // eslint-disable-next-line
    }, [topicsLoading])

    useEffect(() => {
        if (radioButtonValue) {
            if (editState.flag && quizzesData.length > 0) {
                const currentQuiz = quizzesData.find(quiz => quiz.id.toString() === editState.id.toString())
                quizTitleRef.current.value = currentQuiz.title
                setContent(currentQuiz.description)
                setKeywordTags(currentQuiz.keywords.split(' '))
                if (!currentQuiz.topic_id) {
                    let expiryDateAndTime = currentQuiz.end_date?.split(" ") || ["2021-09-08", "11:00:00"]
                    quizTitleRef.current.value = currentQuiz.title
                    // descriptionRef.current.value = currentQuiz.description
                    setKeywordTags(currentQuiz.keywords.split(' '))
                    setExpiryDate(expiryDateAndTime[0].split('-').reverse().join('-'))
                    setExpiryTime(expiryDateAndTime[1])
                    durationRef.current.value = currentQuiz.time_duration.split(':')[0]
                    maxAttemptsRef.current.value = currentQuiz.max_no_of_attempts
                    setScheduleDate(currentQuiz.start_date.split('-').reverse().join('-'))
                }
            }
        }
        // eslint-disable-next-line
    }, [radioButtonValue, quizzesData])

    useEffect(() => {
        if (radioButtonValue) {
            if (editState.flag && quizzesData.length > 0 && coursesData.length > 0) {
                const currentQuiz = quizzesData.find(quiz => quiz.id.toString() === editState.id.toString())
                dispatch(loadTopicsForSelectedCourse(currentQuiz.course_id))
                selectCourseRef.current.value = currentQuiz.courses.title
            }
        }
        // eslint-disable-next-line
    }, [coursesData, quizzesData])

    useEffect(() => {
        if (radioButtonValue) {
            if (editState.flag && topicsData.length > 0) {
                const currentQuiz = quizzesData.find(quiz => quiz.id.toString() === editState.id.toString())
                if (currentQuiz.topic_id) {
                    selectTopicRef.current.value = currentQuiz.topics.title
                }
            }
        }
        // eslint-disable-next-line
    }, [topicsData])

    useEffect(() => {
        dispatch(loadQuizzes())
        dispatch(loadCourses())
        return () => dispatch(resetFormStatus())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setRadioButtonValue(editState.flag ? null : 'mid-term')
        if (!quizzesIsLoading && quizzesData.length > 0) {
            if (editState.flag) {
                dispatch(setHeaderText('Edit Quiz'))
                preFillForm()
            }
            else {
                dispatch(setHeaderText('Add Quiz'))
            }
        }
        // eslint-disable-next-line
    }, [editState, quizzesIsLoading, quizzesData])


    const changeCourseHandler = () => {
        if (!editState.flag) {
            dispatch(loadEmptyTopicsInstantly())
            let courseId = coursesData.find(course => course.title === selectCourseRef.current.value).id
            dispatch(loadTopicsForSelectedCourse(courseId))
            setSelectCourseError(null)
        }
    }

    return (
        <Box
            style={{ gap: '1.5rem' }}
            d='flex'
            flexDir='column'
            width='100%'
            pointerEvents={formStatus.isSubmitting ? 'none' : 'all'}
        >
            <LoadingModal isOpen={isOpen} />
            <FormControl isInvalid={selectCourseError}>
                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="select_course" style={{ fontFamily: 'Mulish, sans-serif' }}>Select Course</FormLabel>
                <Select
                    id="select_course"
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius="13px"
                    height='40px'
                    bgColor='white'
                    placeholder='Select Course'
                    ref={selectCourseRef}
                    disabled={coursesData.length === 0}
                    onChange={changeCourseHandler}
                >
                    {coursesData.length > 0 && coursesData.map((course, idx) => <option key={idx} value={course.title}>{course.title}</option>)}
                </Select>
                <FormErrorMessage fontSize='sm'>{selectCourseError}</FormErrorMessage>
            </FormControl>

            <RadioGroup style={{ fontFamily: 'Mulish, sans-serif' }} pointerEvents={editState.flag ? 'none' : 'all'} fontSize='16px' onChange={setRadioButtonValue} value={radioButtonValue}>
                <Stack direction="row">
                    <Radio value="mid-term" >Mid-Term Quiz</Radio>
                    <Radio value="end-term" >End-Term Quiz</Radio>
                </Stack>
            </RadioGroup>

            {
                radioButtonValue === 'mid-term' &&
                <FormControl isInvalid={selectTopicError}>
                    <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="select_topic" style={{ fontFamily: 'Mulish, sans-serif' }}>Select Topic</FormLabel>
                    <Select
                        id="select_topic"
                        width={['100%', '100%', '90%', '85%']}
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius="13px"
                        height='40px'
                        bgColor='white'
                        placeholder='Select Topic'
                        ref={selectTopicRef}
                        disabled={topicsData.length === 0}
                        onChange={() => setSelectTopicError(null)}
                    >
                        {topicsData.length > 0 && topicsData.map((topic, idx) => <option key={idx} value={topic.title}>{topic.title}</option>)}
                    </Select>
                    <FormErrorMessage fontSize='sm'>{selectTopicError}</FormErrorMessage>
                </FormControl>
            }

            <FormControl isInvalid={quizTitleError}>
                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="quiz_title" style={{ fontFamily: 'Mulish, sans-serif' }}>Quiz Title</FormLabel>
                <Input
                    id="quiz_title"
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius="13px"
                    height='40px'
                    bgColor='white'
                    ref={quizTitleRef}
                    onChange={() => setQuizTitleError(null)}
                />
                <FormErrorMessage fontSize='sm'>{quizTitleError}</FormErrorMessage>
            </FormControl>



            
            <FormControl isInvalid={descriptionError}>
              <FormLabel
                variant="custom"
                htmlFor="course_description"
                style={{ fontFamily: "Mulish, sans-serif" }}
              >
                Instructions before attending quiz
              </FormLabel>

              <Box width={["100%", "100%", "90%", "85%"]} bg='white' borderRadius='13px' minH='200px' >
                <JoditEditor
                  ref={editor}
                  value={content}
                  config={{
                    readOnly: false,
                    uploader: { url: 'none' },
                    removeButtons: ["image", "video", "file", "table", "fullsize", "link", "find"],
                    disablePlugins: ["image-properties", "image-processor", "image", "video", "media", "file", "table", "class-span", "resize-cells", "select-cells", "table-keyboard-navigation", "print", "preview", "fullsize", "search", "link"],
                  }}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => { }}
                />
              </Box>
              <FormErrorMessage fontSize="sm">
                {descriptionError}
              </FormErrorMessage>
            </FormControl>


            <FormControl isInvalid={keywordsError} onSubmit={() => false}>
                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="keywords" style={{ fontFamily: 'Mulish, sans-serif' }}>Keywords</FormLabel>
                <Box
                    d='flex'
                    bgColor='white'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius="13px"
                    minHeight='40px'
                    p='1'
                    flexWrap='wrap'
                >
                    <Box d={keywordTags.length > 0 ? 'flex' : 'none'} justifyContent='space-around'>
                        {
                            keywordTags.length > 0 && keywordTags.map((tag, idx) => <Tags keyword={tag} removeTag={removeTagHandler} key={idx} />)
                        }
                    </Box>
                    <Input
                        id="keywords"
                        bgColor="white"
                        placeholder="Enter Keyword"
                        onKeyDown={keywordKeyPressHandler}
                        border="none"
                        outline="none"
                        p="5px"
                        minW="40%"
                        focusBorderColor="none"
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="600"
                        fontSize="16px"
                        onChange={() => setKeywordsError(null)}
                        height='100%'
                        color='#999999'
                    />

                </Box>
                <FormErrorMessage fontSize='sm'>{keywordsError}</FormErrorMessage>
            </FormControl>
            {
                radioButtonValue === 'end-term' && <>
                    <Box width={['100%', '100%', '90%', '85%']} d='flex' justifyContent='space-between'>
                        <Box width='45%'>

                            <FormControl isInvalid={scheduleDateError}>
                                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="schedule_date" style={{ fontFamily: 'Mulish, sans-serif' }}>Start Date</FormLabel>

                                <Flatpickr
                                    value={scheduleDate}
                                    options={
                                        { dateFormat: 'd-m-Y' }
                                    }
                                    placeholder='dd-mm-yyyy'
                                    onChange={(date, dateStr) => {
                                        setScheduleDate(dateStr)
                                        setScheduleDateError(null)
                                    }}
                                    style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                />

                                <FormErrorMessage fontSize='sm'>{scheduleDateError}</FormErrorMessage>
                            </FormControl>

                        </Box>

                        <Box width='45%'>

                            <FormControl isInvalid={expiryDateError}>
                                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="expiry_date" style={{ fontFamily: 'Mulish, sans-serif' }}>Expiry Date</FormLabel>

                                <Flatpickr
                                    value={expiryDate}
                                    options={
                                        { dateFormat: 'd-m-Y' }
                                    }
                                    placeholder='dd-mm-yyyy'
                                    onChange={(date, dateStr) => {
                                        setExpiryDate(dateStr)
                                        setExpiryDateError(null)
                                    }}
                                    style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                />
                                <FormErrorMessage fontSize='sm'>{expiryDateError}</FormErrorMessage>
                            </FormControl>

                        </Box>
                    </Box>

                    <Box width={['100%', '100%', '90%', '85%']} d='flex' justifyContent='space-between'>

                        <Box width='45%'>

                            <FormControl isInvalid={expiryTimeError}>
                                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="max_attempts" style={{ fontFamily: 'Mulish, sans-serif' }}>Expiry Time</FormLabel>
                                <Flatpickr
                                    value={expiryTime}
                                    options={
                                        {
                                            enableTime: true,
                                            noCalendar: true,
                                            dateFormat: "H:i",
                                            time_24hr: true
                                        }
                                    }
                                    placeholder='hh:mm'
                                    onChange={(date, dateStr) => {
                                        setExpiryTime(dateStr)
                                        setExpiryTimeError(null)
                                    }}
                                    style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                />
                                <FormErrorMessage fontSize='sm'>{expiryTimeError}</FormErrorMessage>
                            </FormControl>

                        </Box>

                        <Box width='45%'>

                            <FormControl isInvalid={durationError}>
                                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="duration" style={{ fontFamily: 'Mulish, sans-serif' }}>Duration (in minutes)</FormLabel>
                                <Input
                                    type='number'
                                    color='#666666'
                                    id="duration"
                                    width='100%'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    borderRadius="13px"
                                    height='40px'
                                    bgColor='white'
                                    ref={durationRef}
                                    fontSize={['9px', '11px', '13px', '16px']}
                                    onChange={() => {
                                        if (durationRef.current.value.trim().length > 0) {
                                            setDurationError(null)
                                        }
                                    }}
                                />
                                <FormErrorMessage fontSize='sm'>{durationError}</FormErrorMessage>
                            </FormControl>

                        </Box>
                    </Box>

                    <Box width={['100%', '100%', '90%', '85%']} d='flex' justifyContent='space-between'>
                        <Box width='45%'>
                            <FormControl isInvalid={maxAttemptsError}>
                                <FormLabel variant='custom' fontSize={['14px', '16px', '18px']} htmlFor="max_attempts" style={{ fontFamily: 'Mulish, sans-serif' }}>Number of Attempts</FormLabel>
                                <Input
                                    type='number'
                                    color='#666666'
                                    id="max_attempts"
                                    width='100%'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    borderRadius="13px"
                                    height='40px'
                                    bgColor='white'
                                    ref={maxAttemptsRef}
                                    fontSize={['9px', '11px', '13px', '16px']}
                                    onChange={() => {
                                        if (maxAttemptsRef.current.value.trim().length > 0) {
                                            setMaxAttemptsError(null)
                                        }
                                    }}
                                />
                                <FormErrorMessage fontSize='sm'>{maxAttemptsError}</FormErrorMessage>
                            </FormControl>

                        </Box>
                    </Box>
                </>
            }

            <Box width={['100%', '100%', '90%', '85%']} d='flex' flexDir={['column', 'column', 'row', 'row']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt='2rem'>
                <Button
                    bgColor='#70B259'
                    color='white'
                    borderRadius='lg'
                    p={['6px 15px', '8px 20px', '12px 30px']}
                    _hover={{ bg: "#64a04f" }}
                    onClick={nextHandler}
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='800'
                    fontSize={['13px', '14px', '16px']}
                    mr={['0', '0', '20px', '18px']}
                    mb={['20px', '20px', '0', '0']}
                    isLoading={formStatus.isSubmitting}
                >
                    Next
                </Button>

                <Button
                    bgColor='white'
                    color='#999999'
                    borderRadius='lg'
                    border='1px solid rgba(0, 0, 0, 0.2)'
                    p={['6px 15px', '8px 20px', '12px 30px']}
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='800'
                    fontSize={['13px', '14px', '16px']}
                    onClick={cancelHandler}
                    disabled={formStatus.isSubmitting}
                >
                    Cancel
                </Button>
            </Box>

        </Box>
    )
}